var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

import model from '../base.model';
import { loginModel } from './login.model';
import { getServerUrl as settingsGetServerUrl } from '../../device/settings.storage';
import { isEmpty } from '../../utils/helpers';
import urls from '../../constants/urls.constant';
import { routes } from '../../constants/routes.constant';
import { getAuthToken } from '../../utils/base64';
import { config } from '../../config/apiConfig';

class resetPasswordModel extends model {

    //region init

    static create() {
        return _extends({}, super.create(), {
            isNewPinRequested: false
        });
    }

    //endregion

    //region api

    static apiPost(requestMethod, params = {}) {
        var _this = this;

        return _asyncToGenerator(function* () {
            const serverModel = _this.mapToServer(params);
            const { urlParams, authParams } = serverModel;

            const authToken = params.isNewPinRequested ? getAuthToken(authParams.email, authParams.password) : null;

            const url = params.isNewPinRequested ? urls.auth.restorePassword(urlParams) : urls.auth.getUserNewPin(urlParams);

            const serverUrl = yield settingsGetServerUrl();
            return requestMethod(serverUrl, url, serverModel.payload, authToken);
        })();
    }

    static processServerResponse(dispatch, params, model, serverResponse, history) {
        const { isNewPinRequested } = params;

        // reset pass
        if (isNewPinRequested) {
            if (serverResponse.result && serverResponse.result.toLowerCase() === 'ok') {
                // 1 auth token from params
                const serverModel = this.mapToServer(params);
                const { authParams } = serverModel;
                const authToken = getAuthToken(authParams.email, authParams.password);

                // 2 model dispatch (register, login)
                const modelClient = model.mapToClient(params);
                modelClient.authToken = authToken;
                dispatch(this.dispatchModel({ model, modelClient }));
                dispatch(loginModel.dispatchModel({ model: loginModel, modelClient }));

                // 3 save authToken
                const cb = data => {
                    history.push(routes.home());
                };
                loginModel.storageSaveAuthToken(loginModel, authToken, authParams.email, cb);
            } else {
                throw `not handled response ${serverResponse}`;
            }
        }
        // generate PIN
        else {
                if (serverResponse.message) {
                    const { pin } = serverResponse.message;
                    const modelClient = model.create();
                    modelClient.pin = pin.toString();
                    modelClient.isNewPinRequested = true;
                    dispatch(this.dispatchModel({ model, modelClient }));
                } else {
                    throw `not handled response ${serverResponse}`;
                }
            }
    }

    //endregion

    //region mapper

    static isClientEmpty(clientModel) {
        return super.isEmpty(clientModel);
    }

    static mapToClient(serverModel) {
        if (isEmpty(serverModel)) {
            return {};
        }

        const { pin, email, password } = serverModel;
        return {
            username: email, // like from server
            pin: pin.toString(),
            email,
            password
        };
    }

    static mapToServer(clientModel) {
        if (super.isEmpty(clientModel)) {
            return {};
        }

        const { pin, email, password } = clientModel;
        return {
            urlParams: {
                username: email,
                email,
                pin
            },
            authParams: {
                email,
                password
            },
            payload: {
                username: email,
                pin,
                password
            }
        };
    }
}

resetPasswordModel.MODEL_NAME = 'resetPasswordModel';
resetPasswordModel.TYPE_REQUEST = 'REQUEST_RESET_PASSWORD_USER';
resetPasswordModel.TYPE_FROM_SERVER = 'SET_RESET_PASSWORD_USER';
resetPasswordModel.TYPE_CLEAR = 'CLEAR_RESET_PASSWORD_USER';
export { resetPasswordModel };


// WEBPACK FOOTER //
// ./~/pluton-core/lib/models/auth/resetPassword.model.js